import React from "react";
import { getAtributo } from "../../../context/FuncionesContext";
import { extraerTextoPlano } from "../../../helper/funciones";
import BotonCopiar from "../../../components/BotonCopiar/BotonCopiar";

const Default = ({ data, cab, hijos, campokey, id_elemento }) => {
  const nombre = getAtributo("nombre", data, cab);
  const defaultValue = getAtributo("default", data, cab);
  const className = getAtributo("className", data, cab);

  const valor = data[campokey] ?? defaultValue;

  const tieneNombre =
    nombre !== null &&
    nombre !== undefined &&
    String(nombre).trim() !== "";

  const tieneValor =
    valor !== null &&
    valor !== undefined &&
    String(valor).trim() !== "";

  const tieneLabelYValor = tieneNombre && tieneValor;

  const tieneCopy =
    String(getAtributo("tiene_copiar", data, cab) ?? "").toLowerCase() === "s";

  const textoCopiar = extraerTextoPlano(
    getAtributo("tiene_copiar_texto", data, cab)
  );

  return (
    <>
      <div
        id={id_elemento}
        className={`tarjeta_grid_item_label_item ${
          tieneLabelYValor
            ? "tarjeta_grid_item_label_item--label-y-valor"
            : ""
        }`}
      >
        {tieneNombre && (
          <div className="vista_label vista_label_fuente">
            {nombre}:
          </div>
        )}

        <div
          className="default-copy-container"
          style={{ width: cab.width }}
        >
          <div className="default-copy-content">
            <div className={`${className ?? ""}`}>{valor}</div>
          </div>

          {tieneCopy && (
            <BotonCopiar
              texto={textoCopiar}
              className="default-copy-button mb-2"
              ariaLabel="Copiar valor"
            />
          )}
        </div>
      </div>

      {hijos?.map((hijo) => hijo)}
    </>
  );
};

export default Default;